import cookie from 'js-cookie';

import { ENABLED_FEATURE_FLAGS_COOKIE } from '~/features/cookies/constants';

export function getEnabledFeatureFlagsCookie() {
  const enabledFeatureFlags = cookie.get(ENABLED_FEATURE_FLAGS_COOKIE)?.split('!');
  return enabledFeatureFlags || [];
}
